import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAbility } from '@/providers';
import { ScreenLoader } from '@/components/loaders';

const ProtectedRoute = ({
  action,
  subject,
  requiredPermissions = [],
  allow,
  children,
  fallback = '/error/403',
}) => {
  const { ability, loading, user } = useAbility();

  if (loading) return <ScreenLoader />;

  const isSuperAdmin = user?.roles?.includes('super-admin');
  const userPermissions = user?.permissions || [];

  const hasCaslAccess = action && subject ? ability.can(action, subject) : false;
  const hasPermissionAccess = requiredPermissions.every(p =>
    userPermissions.includes(p)
  );

  const isAllowed =
    typeof allow === 'boolean' ? allow :
    isSuperAdmin ||
    (action && subject && (hasCaslAccess || hasPermissionAccess)) ||
    (!action && !subject && hasPermissionAccess);

  if (!isAllowed) {
    return <Navigate to={fallback} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  action: PropTypes.string,
  subject: PropTypes.string,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
  allow: PropTypes.bool,
  children: PropTypes.node,
  fallback: PropTypes.string,
};

export default ProtectedRoute;
